import { render, staticRenderFns } from "./CoinOne.vue?vue&type=template&id=1c5c7fc0&"
import script from "./CoinOne.vue?vue&type=script&lang=js&"
export * from "./CoinOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports